import { Component } from '@angular/core';

@Component({
    selector: 'app-member-mis-report',
    templateUrl: './member-mis-report.component.html',
    styleUrls: ['./member-mis-report.component.css'],
    standalone: false
})
export class MemberMisReportComponent {

}
